<template>
  <section :class="[$b(), 'global-wrapper']">
    <div :class="$b('grid')">
      <div
        v-for="article in sizedArticles"
        :key="article.id"
        :class="$b('grid-item', { size: getSize(article) })"
      >
        <ArticleCard
          :width="getSize(article)"
          :media="article.media"
          :url="resolveLocalePath(article.fullSlug)"
          :published-at="article._firstPublishedAt"
          :pre-title-url="article.category && article.category.fullSlug"
          :pre-title="article.category && article.category.title"
          :title="article.title"
          :subtitle="article.subtitle"
          :is-new="article.isNew"
          :word-count="article?.contentWordCounter"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ArticleCardGrid',

  props: {
    articles: {
      type: Array,
      required: true
    }
  },

  setup() {
    const { resolveLocalePath } = useUrlBuilder()

    return { resolveLocalePath }
  },

  data: () => ({
    layout: [
      ['2/4', '1/4', '1/4'],
      ['1/4', '2/4', '1/4'],
      ['1/4', '1/4', '1/4', '1/4'],
      ['1/4', '1/4', '2/4'],
      ['1/4', '1/4', '1/4', '1/4']
    ]
  }),

  computed: {
    sizedArticles () {
      /**
       * Generate a list of articles which respect width overrides
       * set in Dato and ensures no empty spaces
       */

      const rows = []
      const articles = [...this.articles]

      const getRowTotal = row => row.reduce((sum, a) => sum + a.width, 0)

      // Calculate width for a given article
      // - If this is forced to double width: 0.5
      // - If there is already a double width in this row: 0.25
      // - If the modulo of this row equals the index of this article: 0.25 (will stagger double width)
      const getArticleWidth = (article) => {
        const lastRow = rows[rows.length - 1]
        if (article.forceWidth && article.forceDoubleWidth) return 0.5
        if (article.forceWidth) return 0.25
        if (lastRow?.some(article => article.width === 0.5)) return 0.25
        if (rows.length % 4 === lastRow?.length) return 0.5
        return 0.25
      }

      articles.forEach((article) => {
        article.width = getArticleWidth(article)

        // Find first row where the row total + article width <= 1
        let rowIndex = rows.findIndex(
          row => getRowTotal(row) + article.width <= 1
        )
        if (rowIndex === -1) {
          rows.push([])
          rowIndex = rows.length - 1
        }

        rows[rowIndex].push(article)
      })

      return rows.flat()
    }
  },

  methods: {
    getSize (article) {
      return article.width === 0.25 ? '1/4' : '2/4'
    }
  }
}
</script>

<style lang="postcss">
.ArticleCardGrid__grid {
  @apply grid grid-flow-row-dense gap-x-8 gap-y-10;

  @screen sm {
    @apply grid-cols-2 gap-y-lg;
  }

  @screen md {
    @apply grid-cols-3;
  }

  @screen xl {
    @apply grid-cols-4;
  }
}

.ArticleCardGrid__grid-item {
  @apply col-span-full;

  @screen sm {
    &--size-1\/4 {
      @apply col-span-1;
    }

    &--size-2\/4 {
      @apply col-span-2;
    }
  }
}
</style>
